<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.paymentConfirmation') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<div class="row justify-content-center">
    
    <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
            <div class="card-body px-lg-5 py-lg-5">
                <div class="text-center text-muted mb-4">
                    <p class="dark-blue-color"><b>{{ $t('message.welcomeToMedicasure') }}</b></p>
                </div>
                <div class="row justify-content-center">

                </div>
                <div class="row justify-content-center">

                <div class="text-left text-muted mb-4 message-consultation-mail p-3">
                    <p>Veuillez consulter vos <b>emails</b> pour télécharger le <b>reçu de paiement</b></p>
                    <p>Ensuite utilisez vos identifiants habituels pour vous connecter via le bouton ci-dessous</p>
                </div>
                <div class="text-center text-muted mb-4">
                       <b-button class="btn-success" @click="goToLogin" >
                                    {{ $t('message.login') }}
                       </b-button>
                </div>
                </div>
            </div>
        </div>

    </div>
</div>
            </div>
        </div>
    </div>
</template>


<script>
import {
    mapGetters
} from "vuex";
import AppConfig from "../constants/AppConfig";
export default {
    name: 'landing',

    data() {
        return {
            isLoading: true,
            opacity: 1,
            canCancel: false,
            fullPage: false,
        };
    },
    methods: {

        omsubmit: function () {
           // this.$router.push({ name: 'edit-subscriber', params: { subscriber: (JSON.parse(localStorage.getItem('user')))['slug'] } });
        },
                    goToLogin :function(){

               this.$router.push({ name: 'login' });

            },
    },
    mounted() {
       // this.submit();
    }
}
</script>
<!-- End Facebook Pixel Code -->
<style scoped>

</style>
